import * as React from 'react';
import { SearchInput } from 'shared-portal-components-v2';

import OwnerCandidateRow from '@/components/organism/CreateSix/steps/StepOwners/OwnerCandidateRow';
import SelectedOwnerRow from '@/components/organism/CreateSix/steps/StepOwners/SelectedOwnerRow';

export interface StepOwnersSelectedOwner {
  id: string;
  name: string;
  email: string;
  isYou?: boolean;
}

export interface StepOwnersCandidateOwner {
  id: string;
  name: string;
  email: string;
  initials: string;
}

export interface StepOwnersViewProps {
  selectedOwners: StepOwnersSelectedOwner[];
  candidateOwners: StepOwnersCandidateOwner[];
  searchValue: string;
  onSearchValueChange: (nextValue: string) => void;
  onRemoveOwner: (ownerId: string) => void;
  onAddOwner: (ownerId: string) => void;
}

export function StepOwnersView(props: StepOwnersViewProps): React.JSX.Element {
  const {
    selectedOwners,
    candidateOwners,
    searchValue,
    onSearchValueChange,
    onRemoveOwner,
    onAddOwner,
  } = props;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-2">Select SIX Owners</h3>
        <p className="text-muted-foreground text-sm">
          Choose who will have full access to manage this SIX. At least one owner is required.
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <h4 className="text-sm font-medium">
            Selected Owners ({selectedOwners.length})
          </h4>
        </div>

        <div className="space-y-2">
          {selectedOwners.map((selectedOwner) => (
            <SelectedOwnerRow
              key={selectedOwner.id}
              name={selectedOwner.name}
              email={selectedOwner.email}
              isYou={selectedOwner.isYou}
              onRemove={() => {
                onRemoveOwner(selectedOwner.id);
              }}
            />
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <h4 className="text-sm font-medium">Add More Owners</h4>

        <div className="relative">
                  <SearchInput
            value={searchValue}
            onChange={(nextSearchValue: string) => {
              onSearchValueChange(nextSearchValue);
            }}
            placeholder="Search by name or email..."
          />
        </div>

        <div className="space-y-2 max-h-64 overflow-y-auto">
          {candidateOwners.map((candidateOwner) => (
            <OwnerCandidateRow
              key={candidateOwner.id}
              name={candidateOwner.name}
              email={candidateOwner.email}
              initials={candidateOwner.initials}
              onAdd={() => {
                onAddOwner(candidateOwner.id);
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

StepOwnersView.displayName = 'StepOwnersView';

export default StepOwnersView;
